module.exports = __webpack_public_path__ + "img/lngcng.2f473d95.png";